// libs
import React, { memo, useEffect, useState } from "react";

// global components
import Experiment, { Variant } from "shared/components/Experiment";

// helpers
import { setMobileCheckoutData } from "shared/helpers/utils/checkout";

// defs
interface ICheckoutURIProps {
    enabled: boolean;
    queryString: string;
    optimizeID: string;
    allTraffic: boolean;
}

function ShowReactCheckout({ queryString }: { queryString: string }) {
    setMobileCheckoutData(true, queryString);
    return null;
}

function ShowLegacyCheckout() {
    setMobileCheckoutData(false);
    return null;
}

function CheckoutURI({ enabled, queryString, optimizeID, allTraffic }: ICheckoutURIProps) {
    const [renderExperiment, setRenderExperiment] = useState(false);

    useEffect(() => {
        // if allTraffic enabled - then redirect all traffic to react checkout
        if (enabled && allTraffic) {
            setMobileCheckoutData(true, queryString);
            return;
        }

        // if feature disabled set redirection false
        if (enabled === false) {
            setMobileCheckoutData(false);
            return;
        }

        setRenderExperiment(true);
    }, [allTraffic, enabled, queryString]);

    if (renderExperiment === false) {
        return null;
    }

    return (
        <Experiment experimentId={optimizeID} defaultVariant="0" placeholder={null}>
            <Variant value="0">
                <ShowLegacyCheckout />
            </Variant>
            <Variant value="1">
                <ShowReactCheckout queryString={queryString} />
            </Variant>
        </Experiment>
    );
}

export default memo(CheckoutURI);
